import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import {
  getResourceLinks,
  isResourcePath,
} from "../../lib/resourcesNavigation";

interface ResourcesNavigationProps {
  mobile?: boolean;
  onNavigate?: () => void;
}

export function ResourcesNavigation({
  mobile = false,
  onNavigate,
}: ResourcesNavigationProps) {
  const { t, i18n } = useTranslation("common");
  const { pathname } = useLocation();
  const links = getResourceLinks(i18n.language);
  const active = isResourcePath(pathname);

  return (
    <Link
      data-resources-navigation
      data-active={active}
      to={links.hub}
      onClick={onNavigate}
      aria-current={
        pathname.replace(/\/$/, "") === links.hub ? "page" : undefined
      }
      className={`flex min-h-11 shrink-0 items-center whitespace-nowrap rounded-sm transition-colors focus-visible:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ${mobile ? "py-2 text-lg" : ""} ${active ? "text-primary font-medium" : "text-foreground/80 hover:text-primary"}`}
    >
      {t("navigation.freeResources")}
    </Link>
  );
}
